import React from 'react'
import { Grid, Hidden, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  mainContent: {
    background: '#fff',
    borderRadius: '10px',
    height: '100%',
    paddingTop: '20px',
    paddingLeft: '15px',
    boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.15)',
    margin: '0px 6px',
    paddingBottom: '20px',
    marginBottom: '10px',
  },
  linkTitle: {
    cursor: 'pointer',
  },
  img: {
    position: 'relative',
    top: '5px',
    left: '-5px',
  },
  imgArrow: {
    position: 'relative',
    top: '-40px',
    right: '-90%',
  },
  title: {
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '22px',
    display: 'inline-block',
    color: '#039F5E',
  },
  question: {
    fontWeight: 400,
    fontSize: '11px',
    lineHeight: '17px',
    display: 'block',
    color: '#555555',
    paddingLeft: '20px',
  },
  content: {
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '17px',
    display: 'block',
    color: '#555555',
    padding: '0 20px',
    marginTop: '20px',
    textAlign: 'justify',
  },
}))
const InfoView: React.FC = () => {
  const [helpView, setHelpView] = React.useState(false)
  const classes = useStyles()
  return (
    <>
      <Hidden xsDown>
        <Grid container xs={12}>
          <Grid
            item
            xl={12}
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className={classes.mainContent}
          >
            <img className={classes.img} src="/images/help.svg" />
            <span className={classes.title}>راهنمای درخواست دارو</span>
            <span className={classes.question}>
              چگونه درخواست داروی خود را ثبت کنیم؟
            </span>
            <span className={classes.content}>
              کاربر گرامی، شما می توانید از طریق انتخاب گزینه ی
              <span style={{ textDecoration: 'underline', fontWeight: 700 }}>
                {' '}
                درخواست دارو{' '}
              </span>
              از منوی بالا، نسبت به درخواست داروی بدون نسخه یا ثبت نسخه ی مورد
              نظر خود اقدام نمایید. همچنین در صورتیکه نسخه ی شما الکترونیک است
              کافیست کد رهگیری آن را ثبت نمایید. سامانه ی داروگ درخواست شما را
              در سریعترین زمان برای تمامی داروخانه های کشور ارسال و نتیحه آن از
              طریق پیامک برای شما ارسال خواهد شد.
            </span>
          </Grid>
        </Grid>
      </Hidden>
      <Hidden smUp>
        <Grid
          item
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className={classes.mainContent}
        >
          <div
            onClick={(): any => setHelpView(!helpView)}
            className={classes.linkTitle}
          >
            <img className={classes.img} src="/images/help.png" />
            <span className={classes.title}>راهنمای درخواست دارو</span>
            <span className={classes.question}>
              چگونه درخواست داروی خود را ثبت کنیم؟
            </span>
            <img className={classes.imgArrow} src="/images/arrowDown.png" />
          </div>
          {helpView == true && (
            <>
              <span className={classes.content}>
                کاربر گرامی، شما می توانید از طریق انتخاب گزینه ی
                <span style={{ textDecoration: 'underline', fontWeight: 700 }}>
                  {' '}
                  درخواست دارو{' '}
                </span>
                از منوی بالا، نسبت به درخواست داروی بدون نسخه یا ثبت نسخه ی مورد
                نظر خود اقدام نمایید. همچنین در صورتیکه نسخه ی شما الکترونیک است
                کافیست کد رهگیری آن را ثبت نمایید. سامانه ی داروگ درخواست شما را
                در سریعترین زمان برای تمامی داروخانه های کشور ارسال و نتیحه آن
                از طریق پیامک برای شما ارسال خواهد شد.
              </span>
            </>
          )}
        </Grid>
      </Hidden>
    </>
  )
}

export default InfoView
